var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { class: _vm.embedded ? "" : "ma-5", attrs: { flat: "" } },
    [
      _c(
        "v-card-text",
        { class: _vm.embedded ? "pa-3" : "" },
        [
          _vm.loading
            ? _c(
                "div",
                {
                  staticClass:
                    "d-flex flex-column justify-center align-center py-8",
                },
                [
                  _c("v-progress-circular", {
                    attrs: { indeterminate: "", color: "cyan" },
                  }),
                  _c("span", { staticClass: "mt-3 text--secondary" }, [
                    _vm._v(_vm._s(_vm.$t("loading")) + "..."),
                  ]),
                ],
                1
              )
            : _vm.error
            ? _c(
                "v-alert",
                {
                  staticClass: "mb-0",
                  attrs: { type: "error", outlined: "", dense: "" },
                },
                [_vm._v(" " + _vm._s(_vm.error) + " ")]
              )
            : !_vm.sipUsers.length
            ? _c(
                "div",
                { staticClass: "no-data-state" },
                [
                  _c(
                    "v-icon",
                    { attrs: { size: "64", color: "grey lighten-1" } },
                    [_vm._v("mdi-phone-off")]
                  ),
                  _c("span", { staticClass: "no-data-text" }, [
                    _vm._v(_vm._s(_vm.$t("yealink-config-no-sip-users"))),
                  ]),
                ],
                1
              )
            : _c(
                "div",
                { staticClass: "config-content" },
                [
                  _c(
                    "v-alert",
                    {
                      staticClass: "mb-4 sip-warning-alert",
                      attrs: { type: "info", outlined: "", dense: "" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex flex-column flex-sm-row align-start align-sm-center justify-sm-space-between",
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "text-body-2 font-weight-bold" },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("yealink-config-sip-warning"))
                              ),
                            ]
                          ),
                          _c(
                            "v-btn",
                            {
                              staticClass: "mt-2 mt-sm-0 ml-sm-3",
                              attrs: { small: "", outlined: "", color: "info" },
                              on: { click: _vm.openSipPanel },
                            },
                            [
                              _c("v-icon", { attrs: { small: "", left: "" } }, [
                                _vm._v("mdi-account-cog"),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("yealink-config-manage-sip-users")
                                  ) +
                                  " "
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "config-section mb-4" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "section-title mb-4 d-flex align-center",
                        },
                        [
                          _c(
                            "v-icon",
                            { staticClass: "mr-2", attrs: { small: "" } },
                            [_vm._v("mdi-cellphone-link")]
                          ),
                          _c("span", { staticClass: "font-weight-medium" }, [
                            _vm._v(_vm._s(_vm.$t("yealink-config-device"))),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        { attrs: { dense: "" } },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12", md: "6" } },
                            [
                              !_vm.manualMacInput
                                ? _c("v-select", {
                                    attrs: {
                                      items: _vm.deviceMacOptions,
                                      label: _vm.$t(
                                        "yealink-config-mac-address"
                                      ),
                                      outlined: "",
                                      dense: "",
                                      clearable: "",
                                      "prepend-inner-icon": "mdi-ethernet",
                                      hint: " ",
                                      "persistent-hint": "",
                                      rules: _vm.macRules,
                                    },
                                    on: { input: _vm.onMacAddressChange },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "message",
                                          fn: function () {
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "yealink-config-mac-hint"
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "mac-hint-link",
                                                  on: {
                                                    click: function ($event) {
                                                      $event.preventDefault()
                                                      return _vm.openYealinkPanel.apply(
                                                        null,
                                                        arguments
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "yealink-config-add-devices"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                        {
                                          key: "item",
                                          fn: function ({ item }) {
                                            return [
                                              _c(
                                                "v-list-item-content",
                                                [
                                                  _c(
                                                    "v-list-item-title",
                                                    {
                                                      staticClass:
                                                        "d-flex align-center",
                                                    },
                                                    [
                                                      _c("span", {
                                                        staticClass:
                                                          "device-status-pill mr-2",
                                                        class: `device-status-${item.status}`,
                                                      }),
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(item.text) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  _c("v-list-item-subtitle", [
                                                    _vm._v(
                                                      _vm._s(item.value) +
                                                        " — " +
                                                        _vm._s(
                                                          item.modelName ||
                                                            _vm.$t(
                                                              "yealink-config-unknown-model"
                                                            )
                                                        )
                                                    ),
                                                  ]),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                        {
                                          key: "selection",
                                          fn: function ({ item }) {
                                            return [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "d-flex align-center",
                                                },
                                                [
                                                  _c("span", {
                                                    staticClass:
                                                      "device-status-pill mr-2",
                                                    class: `device-status-${item.status}`,
                                                  }),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(item.text) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                        {
                                          key: "append",
                                          fn: function () {
                                            return [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass:
                                                    "mt-1 mac-toggle-icon",
                                                  attrs: { small: "" },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.stopPropagation()
                                                      _vm.manualMacInput = true
                                                    },
                                                  },
                                                },
                                                [_vm._v("mdi-form-textbox")]
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      false,
                                      1720986363
                                    ),
                                    model: {
                                      value: _vm.macAddress,
                                      callback: function ($$v) {
                                        _vm.macAddress = $$v
                                      },
                                      expression: "macAddress",
                                    },
                                  })
                                : _c("v-text-field", {
                                    attrs: {
                                      label: _vm.$t(
                                        "yealink-config-mac-address"
                                      ),
                                      outlined: "",
                                      dense: "",
                                      clearable: "",
                                      "prepend-inner-icon": "mdi-ethernet",
                                      hint: " ",
                                      "persistent-hint": "",
                                      rules: _vm.macRules,
                                    },
                                    on: { input: _vm.formatMacAddress },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "message",
                                        fn: function () {
                                          return [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "yealink-config-mac-hint"
                                                  )
                                                ) +
                                                " "
                                            ),
                                            _c(
                                              "a",
                                              {
                                                staticClass: "mac-hint-link",
                                                on: {
                                                  click: function ($event) {
                                                    $event.preventDefault()
                                                    return _vm.openYealinkPanel.apply(
                                                      null,
                                                      arguments
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "yealink-config-add-devices"
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                      {
                                        key: "append",
                                        fn: function () {
                                          return [
                                            _c(
                                              "v-icon",
                                              {
                                                staticClass:
                                                  "mt-1 mac-toggle-icon",
                                                attrs: { small: "" },
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    _vm.manualMacInput = false
                                                    _vm.onMacAddressChange(
                                                      _vm.macAddress
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "mdi-format-list-bulleted"
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ]),
                                    model: {
                                      value: _vm.macAddress,
                                      callback: function ($$v) {
                                        _vm.macAddress = $$v
                                      },
                                      expression: "macAddress",
                                    },
                                  }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", md: "6" } },
                            [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.phoneModels,
                                  label:
                                    _vm.$t("yealink-config-phone-model") + " *",
                                  "item-text": "name",
                                  "item-value": "id",
                                  "return-object": "",
                                  outlined: "",
                                  dense: "",
                                  rules: [(v) => !!v || _vm.$t("api-required")],
                                  "prepend-inner-icon": "mdi-deskphone",
                                },
                                model: {
                                  value: _vm.selectedModel,
                                  callback: function ($$v) {
                                    _vm.selectedModel = $$v
                                  },
                                  expression: "selectedModel",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "config-section mb-4" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "section-title mb-4 d-flex align-center",
                        },
                        [
                          _c(
                            "v-icon",
                            { staticClass: "mr-2", attrs: { small: "" } },
                            [_vm._v("mdi-account-voice")]
                          ),
                          _c("span", { staticClass: "font-weight-medium" }, [
                            _vm._v(_vm._s(_vm.$t("yealink-config-account"))),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        { attrs: { dense: "" } },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12", md: "6" } },
                            [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.sipUsers,
                                  label:
                                    _vm.$t("yealink-config-select-sip-user") +
                                    " *",
                                  "item-text": (u) =>
                                    `${u.username} — ${u.displayName}`,
                                  "item-value": "username",
                                  "return-object": "",
                                  outlined: "",
                                  dense: "",
                                  rules: [(v) => !!v || _vm.$t("api-required")],
                                  "prepend-inner-icon": "mdi-account-voice",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "item",
                                    fn: function ({ item }) {
                                      return [
                                        _c(
                                          "v-list-item-content",
                                          [
                                            _c(
                                              "v-list-item-title",
                                              {
                                                staticClass: "font-weight-bold",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(item.username) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _c("v-list-item-subtitle", [
                                              _vm._v(_vm._s(item.displayName)),
                                            ]),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "selection",
                                    fn: function ({ item }) {
                                      return [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "font-weight-bold mr-1",
                                          },
                                          [_vm._v(_vm._s(item.username))]
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "text--secondary" },
                                          [
                                            _vm._v(
                                              "— " + _vm._s(item.displayName)
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                                model: {
                                  value: _vm.selectedSipUser,
                                  callback: function ($$v) {
                                    _vm.selectedSipUser = $$v
                                  },
                                  expression: "selectedSipUser",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", md: "6" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label:
                                    _vm.$t("yealink-config-display-name") +
                                    " *",
                                  outlined: "",
                                  dense: "",
                                  rules: [(v) => !!v || _vm.$t("api-required")],
                                  "prepend-inner-icon": "mdi-label",
                                  placeholder: _vm.selectedSipUser
                                    ? _vm.selectedSipUser.displayName
                                    : "",
                                },
                                model: {
                                  value: _vm.displayName,
                                  callback: function ($$v) {
                                    _vm.displayName = $$v
                                  },
                                  expression: "displayName",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm.selectedModel && _vm.selectedModel.id !== "w"
                            ? _c(
                                "v-col",
                                { attrs: { cols: "12", md: "6" } },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.ringTypeOptions,
                                      label: _vm.$t("yealink-config-ring-type"),
                                      outlined: "",
                                      dense: "",
                                      "hide-details": "",
                                      "prepend-inner-icon":
                                        "mdi-bell-ring-outline",
                                    },
                                    model: {
                                      value: _vm.ringType,
                                      callback: function ($$v) {
                                        _vm.ringType = $$v
                                      },
                                      expression: "ringType",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.selectedModel && _vm.selectedModel.dssKeyCount > 0
                            ? _c(
                                "v-col",
                                {
                                  staticClass:
                                    "d-flex align-center justify-center",
                                  attrs: { cols: "12", md: "6" },
                                },
                                [
                                  _c("v-checkbox", {
                                    staticClass: "mt-0 pt-0",
                                    attrs: {
                                      label: _vm.$t(
                                        "yealink-config-exclude-from-dss"
                                      ),
                                      "hide-details": "",
                                      dense: "",
                                    },
                                    on: { change: _vm.generateDefaultDssKeys },
                                    model: {
                                      value: _vm.excludeFromDss,
                                      callback: function ($$v) {
                                        _vm.excludeFromDss = $$v
                                      },
                                      expression: "excludeFromDss",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm.selectedSipUser &&
                      !_vm.selectedSipUser.password &&
                      !_vm.showPasswordInput &&
                      !_vm.passwordManuallySet
                        ? _c(
                            "v-alert",
                            {
                              staticClass: "mt-2 mb-0 alert-centered-icon",
                              attrs: { type: "error", outlined: "", dense: "" },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex flex-column flex-sm-row align-start align-sm-center justify-sm-space-between",
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "text-body-2 font-weight-bold",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "yealink-config-no-password-warning-account",
                                            {
                                              name:
                                                _vm.selectedSipUser
                                                  .displayName ||
                                                _vm.selectedSipUser.username,
                                            }
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "mt-2 mt-sm-0 ml-sm-3",
                                      attrs: {
                                        small: "",
                                        text: "",
                                        color: "primary",
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.showPasswordInput = true
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { small: "", left: "" } },
                                        [_vm._v("mdi-key")]
                                      ),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "yealink-config-set-password"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm.selectedSipUser &&
                      _vm.showPasswordInput &&
                      !_vm.passwordManuallySet
                        ? _c(
                            "v-alert",
                            {
                              staticClass: "mt-2 mb-0",
                              attrs: {
                                type: "info",
                                outlined: "",
                                dense: "",
                                icon: false,
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "d-flex align-center" },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "mr-3",
                                      attrs: { color: "info" },
                                    },
                                    [_vm._v("mdi-key")]
                                  ),
                                  _c("v-text-field", {
                                    staticClass: "mr-3",
                                    staticStyle: { "max-width": "300px" },
                                    attrs: {
                                      label: `${_vm.$t(
                                        "yealink-config-password"
                                      )} (${
                                        _vm.selectedSipUser.displayName ||
                                        _vm.selectedSipUser.username
                                      })`,
                                      type: "password",
                                      dense: "",
                                      "hide-details": "",
                                      outlined: "",
                                    },
                                    model: {
                                      value: _vm.manualPassword,
                                      callback: function ($$v) {
                                        _vm.manualPassword = $$v
                                      },
                                      expression: "manualPassword",
                                    },
                                  }),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        small: "",
                                        color: "primary",
                                        disabled: !_vm.manualPassword,
                                      },
                                      on: { click: _vm.applyManualPassword },
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(_vm.$t("apply")) + " "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { small: "", text: "" },
                                      on: {
                                        click: function ($event) {
                                          _vm.showPasswordInput = false
                                          _vm.manualPassword = ""
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(_vm.$t("cancel")) + " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm.selectedSipUser && _vm.passwordManuallySet
                        ? _c(
                            "v-alert",
                            {
                              staticClass: "mt-2 mb-0",
                              attrs: {
                                type: "warning",
                                outlined: "",
                                dense: "",
                                icon: "mdi-key-alert",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex align-center justify-space-between",
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "text-body-2 font-weight-bold",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "yealink-config-password-manually-set-account",
                                            {
                                              name:
                                                _vm.selectedSipUser
                                                  .displayName ||
                                                _vm.selectedSipUser.username,
                                            }
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        small: "",
                                        text: "",
                                        color: "grey",
                                      },
                                      on: { click: _vm.clearManualPassword },
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { small: "", left: "" } },
                                        [_vm._v("mdi-close")]
                                      ),
                                      _vm._v(
                                        " " + _vm._s(_vm.$t("clear")) + " "
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "config-section mb-4" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "section-title mb-4 d-flex align-center",
                        },
                        [
                          _c(
                            "v-icon",
                            { staticClass: "mr-2", attrs: { small: "" } },
                            [_vm._v("mdi-account-multiple-plus")]
                          ),
                          _c("span", { staticClass: "font-weight-medium" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("yealink-config-additional-accounts")
                              )
                            ),
                          ]),
                          _vm.selectedModel
                            ? _c(
                                "span",
                                { staticClass: "text--secondary ml-2" },
                                [
                                  _vm._v(
                                    "(" +
                                      _vm._s(_vm.additionalAccounts.length) +
                                      "/" +
                                      _vm._s(_vm.maxAdditionalAccounts) +
                                      ")"
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._l(_vm.additionalAccounts, function (acc, idx) {
                        return _c(
                          "div",
                          {
                            key: idx,
                            staticClass: "additional-account-row mb-3",
                          },
                          [
                            _c(
                              "v-row",
                              { attrs: { dense: "" } },
                              [
                                _c(
                                  "v-col",
                                  { attrs: { cols: "12", md: "6" } },
                                  [
                                    _c("v-select", {
                                      attrs: {
                                        items: _vm.getAvailableSipUsersFor(idx),
                                        label: `${_vm.$t(
                                          "yealink-config-select-sip-user"
                                        )} (${idx + 2})`,
                                        "item-text": "displayName",
                                        "item-value": "username",
                                        "return-object": "",
                                        outlined: "",
                                        dense: "",
                                        "prepend-inner-icon":
                                          "mdi-account-voice",
                                        hint: acc.sipUser
                                          ? `${_vm.$t(
                                              "yealink-config-extension"
                                            )}: ${acc.sipUser.username}`
                                          : "",
                                        "persistent-hint": "",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.onAdditionalAccountChange(
                                            idx
                                          )
                                        },
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "item",
                                            fn: function ({ item }) {
                                              return [
                                                _c(
                                                  "v-list-item-content",
                                                  [
                                                    _c("v-list-item-title", [
                                                      _vm._v(
                                                        _vm._s(item.displayName)
                                                      ),
                                                    ]),
                                                    _c("v-list-item-subtitle", [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "yealink-config-extension"
                                                            )
                                                          ) +
                                                          ": " +
                                                          _vm._s(
                                                            item.username
                                                          ) +
                                                          " "
                                                      ),
                                                    ]),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                      model: {
                                        value: acc.sipUser,
                                        callback: function ($$v) {
                                          _vm.$set(acc, "sipUser", $$v)
                                        },
                                        expression: "acc.sipUser",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "12", md: "6" } },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        label: `${_vm.$t(
                                          "yealink-config-display-name"
                                        )} (${idx + 2})`,
                                        outlined: "",
                                        dense: "",
                                        "prepend-inner-icon": "mdi-label",
                                        placeholder: acc.sipUser
                                          ? acc.sipUser.displayName
                                          : "",
                                      },
                                      model: {
                                        value: acc.displayName,
                                        callback: function ($$v) {
                                          _vm.$set(acc, "displayName", $$v)
                                        },
                                        expression: "acc.displayName",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "12" } },
                                  [
                                    _c(
                                      "v-row",
                                      {
                                        attrs: { dense: "", "no-gutters": "" },
                                      },
                                      [
                                        _vm.selectedModel &&
                                        _vm.selectedModel.id !== "w"
                                          ? _c(
                                              "v-col",
                                              {
                                                attrs: { cols: "12", md: "6" },
                                              },
                                              [
                                                _c("v-select", {
                                                  attrs: {
                                                    items: _vm.ringTypeOptions,
                                                    label: `${_vm.$t(
                                                      "yealink-config-ring-type"
                                                    )} (${idx + 2})`,
                                                    outlined: "",
                                                    dense: "",
                                                    "hide-details": "",
                                                    "prepend-inner-icon":
                                                      "mdi-bell-ring-outline",
                                                  },
                                                  model: {
                                                    value: acc.ringType,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        acc,
                                                        "ringType",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "acc.ringType",
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _c(
                                          "v-col",
                                          {
                                            staticClass:
                                              "d-flex align-center justify-center pl-md-3 mt-2 mt-md-0",
                                            attrs: { cols: "12", md: "6" },
                                          },
                                          [
                                            _vm.selectedModel &&
                                            _vm.selectedModel.dssKeyCount > 0
                                              ? _c("v-checkbox", {
                                                  staticClass: "mt-0 pt-0 mr-2",
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "yealink-config-exclude-from-dss"
                                                    ),
                                                    "hide-details": "",
                                                    dense: "",
                                                  },
                                                  on: {
                                                    change:
                                                      _vm.generateDefaultDssKeys,
                                                  },
                                                  model: {
                                                    value: acc.excludeFromDss,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        acc,
                                                        "excludeFromDss",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "acc.excludeFromDss",
                                                  },
                                                })
                                              : _vm._e(),
                                            _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  small: "",
                                                  text: "",
                                                  color: "error",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.removeAdditionalAccount(
                                                      idx
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      small: "",
                                                      left: "",
                                                    },
                                                  },
                                                  [_vm._v("mdi-delete")]
                                                ),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "yealink-config-delete-account"
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            acc.sipUser &&
                            !acc.sipUser.password &&
                            !acc.showPasswordInput &&
                            !acc.passwordManuallySet
                              ? _c(
                                  "v-alert",
                                  {
                                    staticClass:
                                      "mt-2 mb-0 alert-centered-icon",
                                    attrs: {
                                      type: "error",
                                      outlined: "",
                                      dense: "",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex flex-column flex-sm-row align-start align-sm-center justify-sm-space-between",
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "text-body-2 font-weight-bold",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "yealink-config-no-password-warning-account",
                                                  {
                                                    name:
                                                      acc.sipUser.displayName ||
                                                      acc.sipUser.username,
                                                  }
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "v-btn",
                                          {
                                            staticClass: "mt-2 mt-sm-0 ml-sm-3",
                                            attrs: {
                                              small: "",
                                              text: "",
                                              color: "primary",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.$set(
                                                  acc,
                                                  "showPasswordInput",
                                                  true
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                attrs: { small: "", left: "" },
                                              },
                                              [_vm._v("mdi-key")]
                                            ),
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "yealink-config-set-password"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            acc.sipUser &&
                            acc.showPasswordInput &&
                            !acc.passwordManuallySet
                              ? _c(
                                  "v-alert",
                                  {
                                    staticClass: "mt-2 mb-0",
                                    attrs: {
                                      type: "info",
                                      outlined: "",
                                      dense: "",
                                      icon: false,
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "d-flex align-center" },
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            staticClass: "mr-3",
                                            attrs: { color: "info" },
                                          },
                                          [_vm._v("mdi-key")]
                                        ),
                                        _c("v-text-field", {
                                          staticClass: "mr-3",
                                          staticStyle: { "max-width": "300px" },
                                          attrs: {
                                            label: `${_vm.$t(
                                              "yealink-config-password"
                                            )} (${
                                              acc.sipUser.displayName ||
                                              acc.sipUser.username
                                            })`,
                                            type: "password",
                                            dense: "",
                                            "hide-details": "",
                                            outlined: "",
                                          },
                                          model: {
                                            value: acc.manualPassword,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                acc,
                                                "manualPassword",
                                                $$v
                                              )
                                            },
                                            expression: "acc.manualPassword",
                                          },
                                        }),
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              small: "",
                                              color: "primary",
                                              disabled: !acc.manualPassword,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.applyAdditionalPassword(
                                                  idx
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.$t("apply")) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: { small: "", text: "" },
                                            on: {
                                              click: function ($event) {
                                                _vm.$set(
                                                  acc,
                                                  "showPasswordInput",
                                                  false
                                                )
                                                _vm.$set(
                                                  acc,
                                                  "manualPassword",
                                                  ""
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.$t("cancel")) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            acc.sipUser && acc.passwordManuallySet
                              ? _c(
                                  "v-alert",
                                  {
                                    staticClass: "mt-2 mb-0",
                                    attrs: {
                                      type: "warning",
                                      outlined: "",
                                      dense: "",
                                      icon: "mdi-key-alert",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex align-center justify-space-between",
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "text-body-2 font-weight-bold",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "yealink-config-password-manually-set-account",
                                                  {
                                                    name:
                                                      acc.sipUser.displayName ||
                                                      acc.sipUser.username,
                                                  }
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              small: "",
                                              text: "",
                                              color: "grey",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.clearAdditionalPassword(
                                                  idx
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                attrs: { small: "", left: "" },
                                              },
                                              [_vm._v("mdi-close")]
                                            ),
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.$t("clear")) +
                                                " "
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      }),
                      _c(
                        "v-btn",
                        {
                          staticClass: "mt-1",
                          attrs: {
                            "x-small": "",
                            text: "",
                            color: "primary",
                            disabled:
                              !_vm.selectedSipUser ||
                              !_vm.selectedModel ||
                              _vm.additionalAccounts.length >=
                                _vm.maxAdditionalAccounts,
                          },
                          on: { click: _vm.addAdditionalAccount },
                        },
                        [
                          _c("v-icon", { attrs: { "x-small": "", left: "" } }, [
                            _vm._v("mdi-plus"),
                          ]),
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("yealink-config-add-account")) +
                              " "
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                  _vm.selectedSipUser &&
                  _vm.selectedModel &&
                  _vm.isWirelessModel
                    ? _c(
                        "div",
                        { staticClass: "advanced-settings mb-4" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "section-title mb-2 d-flex align-center",
                            },
                            [
                              _c(
                                "v-icon",
                                { staticClass: "mr-2", attrs: { small: "" } },
                                [_vm._v("mdi-cellphone-wireless")]
                              ),
                              _c(
                                "span",
                                { staticClass: "font-weight-medium" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "yealink-config-handset-association"
                                      )
                                    )
                                  ),
                                ]
                              ),
                              _c(
                                "span",
                                { staticClass: "text--secondary ml-2" },
                                [
                                  _vm._v(
                                    "(" +
                                      _vm._s(_vm.handsets.length) +
                                      "/" +
                                      _vm._s(_vm.maxHandsets) +
                                      ")"
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "handset-list" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex align-center text--secondary text-caption mb-1",
                                  staticStyle: { "padding-left": "4px" },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        width: "24px",
                                        "flex-shrink": "0",
                                      },
                                    },
                                    [_vm._v("#")]
                                  ),
                                  _c("span", { staticClass: "flex-grow-1" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("yealink-config-handset-account")
                                      )
                                    ),
                                  ]),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        width: "56px",
                                        "text-align": "center",
                                        "flex-shrink": "0",
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("actions")))]
                                  ),
                                ]
                              ),
                              _vm._l(_vm.handsets, function (hs, idx) {
                                return _c(
                                  "div",
                                  {
                                    key: idx,
                                    staticClass: "d-flex align-center mb-1",
                                    staticStyle: { "padding-left": "4px" },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "text-body-2 text--secondary font-weight-medium",
                                        staticStyle: {
                                          width: "24px",
                                          "flex-shrink": "0",
                                        },
                                      },
                                      [_vm._v(_vm._s(hs.index))]
                                    ),
                                    _c("v-select", {
                                      staticClass: "dss-input flex-grow-1",
                                      attrs: {
                                        items: _vm.handsetAccountOptions,
                                        "item-text": "text",
                                        "item-value": "value",
                                        dense: "",
                                        "hide-details": "",
                                        outlined: "",
                                      },
                                      model: {
                                        value: hs.account,
                                        callback: function ($$v) {
                                          _vm.$set(hs, "account", _vm._n($$v))
                                        },
                                        expression: "hs.account",
                                      },
                                    }),
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          width: "56px",
                                          "flex-shrink": "0",
                                          "text-align": "center",
                                        },
                                      },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              icon: "",
                                              "x-small": "",
                                              color: "error",
                                              disabled: idx === 0,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.removeHandset(idx)
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              { attrs: { "x-small": "" } },
                                              [_vm._v("mdi-delete")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              }),
                            ],
                            2
                          ),
                          _c(
                            "v-btn",
                            {
                              staticClass: "mt-2",
                              attrs: {
                                "x-small": "",
                                text: "",
                                color: "primary",
                                disabled:
                                  _vm.handsets.length >= _vm.maxHandsets,
                              },
                              on: { click: _vm.addHandset },
                            },
                            [
                              _c(
                                "v-icon",
                                { attrs: { "x-small": "", left: "" } },
                                [_vm._v("mdi-plus")]
                              ),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("yealink-config-add-handset")) +
                                  " "
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.selectedSipUser && _vm.selectedModel
                    ? _c(
                        "div",
                        { staticClass: "dss-preview mb-4" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "section-title mb-2 d-flex align-center",
                            },
                            [
                              _c(
                                "v-icon",
                                { staticClass: "mr-2", attrs: { small: "" } },
                                [_vm._v("mdi-dialpad")]
                              ),
                              _c(
                                "span",
                                { staticClass: "font-weight-medium" },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("yealink-config-dss-keys"))
                                  ),
                                ]
                              ),
                              _vm.dssKeysEnabled
                                ? _c(
                                    "span",
                                    { staticClass: "text--secondary ml-2" },
                                    [
                                      _vm._v(
                                        "(" +
                                          _vm._s(_vm.dssKeys.length) +
                                          "/" +
                                          _vm._s(_vm.maxDssKeys) +
                                          ")"
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _c("v-spacer"),
                              _c("v-switch", {
                                staticClass: "mt-0 pt-0 mr-1",
                                attrs: {
                                  "hide-details": "",
                                  dense: "",
                                  inset: "",
                                  disabled:
                                    _vm.selectedModel &&
                                    _vm.selectedModel.dssKeyCount === 0,
                                },
                                model: {
                                  value: _vm.dssKeysEnabled,
                                  callback: function ($$v) {
                                    _vm.dssKeysEnabled = $$v
                                  },
                                  expression: "dssKeysEnabled",
                                },
                              }),
                              _vm.dssKeysEnabled
                                ? _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        "x-small": "",
                                        text: "",
                                        color: "grey",
                                      },
                                      on: { click: _vm.resetDssKeys },
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { "x-small": "", left: "" } },
                                        [_vm._v("mdi-refresh")]
                                      ),
                                      _vm._v(
                                        " " + _vm._s(_vm.$t("reset")) + " "
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          !_vm.dssKeysEnabled
                            ? _c(
                                "div",
                                { staticClass: "dss-disabled-message" },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { color: "grey", size: "40" } },
                                    [_vm._v("mdi-dialpad")]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "text--secondary text-body-2 mt-2",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.selectedModel &&
                                            _vm.selectedModel.dssKeyCount === 0
                                            ? _vm.$t(
                                                "yealink-config-dss-not-supported"
                                              )
                                            : _vm.$t(
                                                "yealink-config-dss-disabled"
                                              )
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex flex-wrap align-center justify-space-between mb-3",
                                    staticStyle: { gap: "16px" },
                                  },
                                  [
                                    _c("v-checkbox", {
                                      staticClass: "mt-0",
                                      attrs: {
                                        label: _vm.$t(
                                          "yealink-config-enable-intercom"
                                        ),
                                        "hide-details": "",
                                        dense: "",
                                      },
                                      on: { change: _vm.onIntercomToggle },
                                      model: {
                                        value: _vm.intercomEnabled,
                                        callback: function ($$v) {
                                          _vm.intercomEnabled = $$v
                                        },
                                        expression: "intercomEnabled",
                                      },
                                    }),
                                    _c("v-select", {
                                      staticStyle: {
                                        "max-width": "220px",
                                        "min-width": "180px",
                                      },
                                      attrs: {
                                        items: _vm.dssKeyLengthOptions,
                                        label: _vm.$t(
                                          "yealink-config-dss-key-length"
                                        ),
                                        outlined: "",
                                        dense: "",
                                        "hide-details": "",
                                      },
                                      model: {
                                        value: _vm.dssKeyLength,
                                        callback: function ($$v) {
                                          _vm.dssKeyLength = $$v
                                        },
                                        expression: "dssKeyLength",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "dss-table-scroll" },
                                  [
                                    _c("v-simple-table", {
                                      staticClass: "dss-table",
                                      attrs: { dense: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function () {
                                              return [
                                                _c("thead", [
                                                  _c("tr", [
                                                    _c("th", {
                                                      staticStyle: {
                                                        width: "40px",
                                                      },
                                                    }),
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-left",
                                                        staticStyle: {
                                                          width: "50px",
                                                        },
                                                      },
                                                      [_vm._v(" # ")]
                                                    ),
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-left",
                                                        staticStyle: {
                                                          "min-width": "110px",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "yealink-config-type"
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-left",
                                                        staticStyle: {
                                                          "min-width": "120px",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "yealink-config-label"
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-left",
                                                        staticStyle: {
                                                          "min-width": "120px",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "yealink-config-value"
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-left",
                                                        staticStyle: {
                                                          width: "70px",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "yealink-config-line"
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-center",
                                                        staticStyle: {
                                                          width: "50px",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t("actions")
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]),
                                                ]),
                                                _c(
                                                  "draggable",
                                                  {
                                                    attrs: {
                                                      tag: "tbody",
                                                      handle: ".drag-handle",
                                                      filter: ".no-drag",
                                                      "prevent-on-filter": false,
                                                    },
                                                    on: { end: _vm.onDragEnd },
                                                    model: {
                                                      value: _vm.dssKeys,
                                                      callback: function ($$v) {
                                                        _vm.dssKeys = $$v
                                                      },
                                                      expression: "dssKeys",
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.dssKeys,
                                                    function (key, idx) {
                                                      return _c(
                                                        "tr",
                                                        {
                                                          key: idx,
                                                          staticClass:
                                                            "dss-row",
                                                          class: {
                                                            "no-drag":
                                                              _vm.isLignesKey(
                                                                key
                                                              ),
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "icon-cell",
                                                              class: {
                                                                "drag-handle":
                                                                  !_vm.isLignesKey(
                                                                    key
                                                                  ),
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-icon",
                                                                {
                                                                  staticClass:
                                                                    "drag-icon",
                                                                  attrs: {
                                                                    small: "",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.isLignesKey(
                                                                        key
                                                                      )
                                                                        ? "mdi-lock"
                                                                        : "mdi-drag"
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c("td", [
                                                            _vm._v(
                                                              _vm._s(key.index)
                                                            ),
                                                          ]),
                                                          _c(
                                                            "td",
                                                            [
                                                              _c("v-select", {
                                                                staticClass:
                                                                  "dss-select",
                                                                attrs: {
                                                                  items:
                                                                    _vm.dssKeyTypes,
                                                                  "item-text":
                                                                    "text",
                                                                  "item-value":
                                                                    "value",
                                                                  dense: "",
                                                                  "hide-details":
                                                                    "",
                                                                  outlined: "",
                                                                },
                                                                on: {
                                                                  change:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.onDssTypeChange(
                                                                        key
                                                                      )
                                                                    },
                                                                },
                                                                model: {
                                                                  value:
                                                                    key.type,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        key,
                                                                        "type",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "key.type",
                                                                },
                                                              }),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "td",
                                                            [
                                                              _c(
                                                                "v-text-field",
                                                                {
                                                                  staticClass:
                                                                    "dss-input",
                                                                  attrs: {
                                                                    dense: "",
                                                                    "hide-details":
                                                                      "",
                                                                    outlined:
                                                                      "",
                                                                    readonly:
                                                                      key.type ===
                                                                        0 ||
                                                                      key.type ===
                                                                        24,
                                                                    disabled:
                                                                      key.type ===
                                                                        0 ||
                                                                      key.type ===
                                                                        24,
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      key.label,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          key,
                                                                          "label",
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "key.label",
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "td",
                                                            [
                                                              _c(
                                                                "v-text-field",
                                                                {
                                                                  staticClass:
                                                                    "dss-input",
                                                                  attrs: {
                                                                    dense: "",
                                                                    "hide-details":
                                                                      "",
                                                                    outlined:
                                                                      "",
                                                                    readonly:
                                                                      key.type ===
                                                                        -1 ||
                                                                      key.type ===
                                                                        0 ||
                                                                      key.type ===
                                                                        24,
                                                                    disabled:
                                                                      key.type ===
                                                                        -1 ||
                                                                      key.type ===
                                                                        0 ||
                                                                      key.type ===
                                                                        24,
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      key.value,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          key,
                                                                          "value",
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "key.value",
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "td",
                                                            [
                                                              _c(
                                                                "v-text-field",
                                                                {
                                                                  staticClass:
                                                                    "dss-input",
                                                                  attrs: {
                                                                    type: "number",
                                                                    dense: "",
                                                                    "hide-details":
                                                                      "",
                                                                    outlined:
                                                                      "",
                                                                    readonly:
                                                                      key.type !==
                                                                      -1,
                                                                    disabled:
                                                                      key.type !==
                                                                      -1,
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      key.line,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          key,
                                                                          "line",
                                                                          _vm._n(
                                                                            $$v
                                                                          )
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "key.line",
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "text-center",
                                                            },
                                                            [
                                                              _c(
                                                                "v-btn",
                                                                {
                                                                  attrs: {
                                                                    icon: "",
                                                                    "x-small":
                                                                      "",
                                                                    color:
                                                                      "error",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.removeDssKey(
                                                                          idx
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-icon",
                                                                    {
                                                                      attrs: {
                                                                        "x-small":
                                                                          "",
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "mdi-delete"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        false,
                                        1596777830
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "mt-2",
                                    attrs: {
                                      "x-small": "",
                                      text: "",
                                      color: "primary",
                                      disabled:
                                        _vm.dssKeys.length >= _vm.maxDssKeys,
                                    },
                                    on: { click: _vm.addDssKey },
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      { attrs: { "x-small": "", left: "" } },
                                      [_vm._v("mdi-plus")]
                                    ),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("yealink-config-add-dss-key")
                                        ) +
                                        " "
                                    ),
                                  ],
                                  1
                                ),
                              ],
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm.selectedSipUser && _vm.selectedModel
                    ? _c(
                        "div",
                        { staticClass: "advanced-settings mb-4" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "section-title mb-4 d-flex align-center",
                            },
                            [
                              _c(
                                "v-icon",
                                { staticClass: "mr-2", attrs: { small: "" } },
                                [_vm._v("mdi-cog-outline")]
                              ),
                              _c(
                                "span",
                                { staticClass: "font-weight-medium" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("yealink-config-advanced-settings")
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-row",
                            { attrs: { dense: "" } },
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "6", md: "3" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: _vm.$t("yealink-config-sip-port"),
                                      type: "number",
                                      outlined: "",
                                      dense: "",
                                      hint: _vm.$t(
                                        "yealink-config-sip-port-hint"
                                      ),
                                      "persistent-hint": "",
                                      rules: _vm.portRules,
                                    },
                                    model: {
                                      value: _vm.sipPort,
                                      callback: function ($$v) {
                                        _vm.sipPort = _vm._n($$v)
                                      },
                                      expression: "sipPort",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "6", md: "3" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: _vm.$t("yealink-config-rtp-min"),
                                      type: "number",
                                      outlined: "",
                                      dense: "",
                                      rules: _vm.portRules,
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "append",
                                          fn: function () {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex flex-column",
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      staticClass:
                                                        "rtp-stepper",
                                                      attrs: { small: "" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          _vm.rtpMinPort += 2000
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("mdi-chevron-up")]
                                                  ),
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      staticClass:
                                                        "rtp-stepper",
                                                      attrs: { small: "" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          _vm.rtpMinPort -= 2000
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("mdi-chevron-down")]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      false,
                                      3946361283
                                    ),
                                    model: {
                                      value: _vm.rtpMinPort,
                                      callback: function ($$v) {
                                        _vm.rtpMinPort = _vm._n($$v)
                                      },
                                      expression: "rtpMinPort",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "6", md: "3" } },
                                [
                                  _c("v-text-field", {
                                    class: {
                                      "rtp-max-error": _vm.rtpMaxPort > 65535,
                                    },
                                    attrs: {
                                      value: _vm.rtpMaxPort,
                                      label: _vm.$t("yealink-config-rtp-max"),
                                      type: "number",
                                      outlined: "",
                                      dense: "",
                                      readonly: "",
                                      disabled: "",
                                      error: _vm.rtpMaxPort > 65535,
                                      "error-messages":
                                        _vm.rtpMaxPort > 65535
                                          ? [
                                              _vm.$t(
                                                "yealink-config-port-max-error"
                                              ),
                                            ]
                                          : [],
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "6", md: "3" } },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.natTraversalOptions,
                                      label: _vm.$t(
                                        "yealink-config-nat-traversal"
                                      ),
                                      "item-text": "text",
                                      "item-value": "value",
                                      outlined: "",
                                      dense: "",
                                    },
                                    on: { blur: _vm.onNetworkSettingBlur },
                                    model: {
                                      value: _vm.natTraversal,
                                      callback: function ($$v) {
                                        _vm.natTraversal = $$v
                                      },
                                      expression: "natTraversal",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "6", md: "3" } },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.transportTypeOptions,
                                      label: _vm.$t(
                                        "yealink-config-transport-type"
                                      ),
                                      "item-text": "text",
                                      "item-value": "value",
                                      outlined: "",
                                      dense: "",
                                    },
                                    on: { blur: _vm.onNetworkSettingBlur },
                                    model: {
                                      value: _vm.transportType,
                                      callback: function ($$v) {
                                        _vm.transportType = $$v
                                      },
                                      expression: "transportType",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "6", md: "5" } },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.timezoneOptions,
                                      label: _vm.$t("yealink-config-timezone"),
                                      "item-text": "text",
                                      "item-value": "value",
                                      outlined: "",
                                      dense: "",
                                    },
                                    model: {
                                      value: _vm.timezone,
                                      callback: function ($$v) {
                                        _vm.timezone = $$v
                                      },
                                      expression: "timezone",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "6", md: "4" } },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.guiLanguageOptions,
                                      label: _vm.$t("yealink-config-language"),
                                      "item-text": "text",
                                      "item-value": "value",
                                      outlined: "",
                                      dense: "",
                                    },
                                    model: {
                                      value: _vm.guiLanguage,
                                      callback: function ($$v) {
                                        _vm.guiLanguage = $$v
                                      },
                                      expression: "guiLanguage",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "6", md: "3" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: _vm.$t(
                                        "yealink-config-wan-vlan-id"
                                      ),
                                      outlined: "",
                                      dense: "",
                                      hint: _vm.$t(
                                        "yealink-config-wan-vlan-hint"
                                      ),
                                      "persistent-hint": "",
                                      rules: _vm.vlanRules,
                                      placeholder: "100",
                                    },
                                    on: { blur: _vm.onNetworkSettingBlur },
                                    model: {
                                      value: _vm.wanVlanId,
                                      callback: function ($$v) {
                                        _vm.wanVlanId = $$v
                                      },
                                      expression: "wanVlanId",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.selectedSipUser &&
                          _vm.sipPort !== _vm.expectedSipPort
                            ? _c(
                                "v-alert",
                                {
                                  staticClass: "mt-2 mb-0 alert-centered-icon",
                                  attrs: {
                                    type: "warning",
                                    outlined: "",
                                    dense: "",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex align-center justify-space-between",
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "text-body-2 font-weight-bold",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "yealink-config-sip-port-mismatch",
                                                {
                                                  expected: _vm.expectedSipPort,
                                                  actual: _vm.sipPort,
                                                }
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            small: "",
                                            text: "",
                                            color: "warning",
                                          },
                                          on: {
                                            click: function ($event) {
                                              _vm.sipPort = _vm.expectedSipPort
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { small: "", left: "" } },
                                            [_vm._v("mdi-refresh")]
                                          ),
                                          _vm._v(
                                            " " + _vm._s(_vm.$t("reset")) + " "
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm.selectedSipUser &&
                          _vm.rtpMinPort !== _vm.expectedRtpMinPort
                            ? _c(
                                "v-alert",
                                {
                                  staticClass: "mt-2 mb-0 alert-centered-icon",
                                  attrs: {
                                    type: "warning",
                                    outlined: "",
                                    dense: "",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex align-center justify-space-between",
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "text-body-2 font-weight-bold",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "yealink-config-rtp-port-mismatch",
                                                {
                                                  expected:
                                                    _vm.expectedRtpMinPort,
                                                  actual: _vm.rtpMinPort,
                                                }
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            small: "",
                                            text: "",
                                            color: "warning",
                                          },
                                          on: {
                                            click: function ($event) {
                                              _vm.rtpMinPort =
                                                _vm.expectedRtpMinPort
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { small: "", left: "" } },
                                            [_vm._v("mdi-refresh")]
                                          ),
                                          _vm._v(
                                            " " + _vm._s(_vm.$t("reset")) + " "
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.selectedSipUser && _vm.selectedModel
                    ? _c(
                        "div",
                        { staticClass: "config-preview mb-4" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "section-title mb-2 d-flex align-center",
                            },
                            [
                              _c(
                                "v-icon",
                                { staticClass: "mr-2", attrs: { small: "" } },
                                [_vm._v("mdi-file-document-outline")]
                              ),
                              _c(
                                "span",
                                { staticClass: "font-weight-medium" },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("yealink-config-preview"))
                                  ),
                                ]
                              ),
                              _c("v-spacer"),
                              _vm.selectedDeviceId
                                ? [
                                    _vm.currentConfigLoading
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "d-flex align-center",
                                          },
                                          [
                                            _c("v-progress-circular", {
                                              staticClass: "mr-2",
                                              attrs: {
                                                indeterminate: "",
                                                size: "16",
                                                width: "2",
                                                color: "cyan",
                                              },
                                            }),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "text-caption text--secondary",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "yealink-config-diff-loading"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm.currentConfig &&
                                    !_vm.currentConfigLoading
                                      ? _c(
                                          "v-chip",
                                          {
                                            attrs: {
                                              "x-small": "",
                                              color: "success",
                                              outlined: "",
                                            },
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                attrs: {
                                                  "x-small": "",
                                                  left: "",
                                                },
                                              },
                                              [_vm._v("mdi-check-circle")]
                                            ),
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "yealink-config-diff-loaded"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          ),
                          _vm.currentConfigError
                            ? _c(
                                "v-alert",
                                {
                                  staticClass: "mb-2",
                                  attrs: {
                                    type: "error",
                                    outlined: "",
                                    dense: "",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex align-center justify-space-between",
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "text-body-2" },
                                        [_vm._v(_vm._s(_vm.currentConfigError))]
                                      ),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            small: "",
                                            text: "",
                                            color: "error",
                                            loading: _vm.currentConfigLoading,
                                          },
                                          on: { click: _vm.fetchCurrentConfig },
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { small: "", left: "" } },
                                            [_vm._v("mdi-refresh")]
                                          ),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "yealink-config-diff-retry"
                                                )
                                              ) +
                                              " "
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm.currentConfig && _vm.configDiff
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "diff-summary mb-2 d-flex align-center flex-wrap",
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "diff-badge diff-badge-added",
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "mr-1",
                                          attrs: {
                                            "x-small": "",
                                            color: "#4caf50",
                                          },
                                        },
                                        [_vm._v("mdi-plus-circle")]
                                      ),
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.configDiff.added) +
                                          " " +
                                          _vm._s(
                                            _vm.$t("yealink-config-diff-added")
                                          ) +
                                          " "
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "diff-badge diff-badge-modified",
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "mr-1",
                                          attrs: {
                                            "x-small": "",
                                            color: "#ff9800",
                                          },
                                        },
                                        [_vm._v("mdi-pencil-circle")]
                                      ),
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.configDiff.modified) +
                                          " " +
                                          _vm._s(
                                            _vm.$t(
                                              "yealink-config-diff-modified"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "diff-badge diff-badge-unchanged",
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "mr-1",
                                          attrs: {
                                            "x-small": "",
                                            color: "grey",
                                          },
                                        },
                                        [_vm._v("mdi-check-circle-outline")]
                                      ),
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.configDiff.unchanged) +
                                          " " +
                                          _vm._s(
                                            _vm.$t(
                                              "yealink-config-diff-unchanged"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "diff-badge diff-badge-removed",
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "mr-1",
                                          attrs: {
                                            "x-small": "",
                                            color: "#f44336",
                                          },
                                        },
                                        [_vm._v("mdi-minus-circle")]
                                      ),
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.configDiff.removed) +
                                          " " +
                                          _vm._s(
                                            _vm.$t(
                                              "yealink-config-diff-not-in-config"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _c("pre", {
                            staticClass: "config-preview-box",
                            domProps: {
                              innerHTML: _vm._s(_vm.configPreviewHighlighted),
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    {
                      staticClass:
                        "config-actions d-flex flex-wrap justify-end gap-2",
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { outlined: "", color: "grey" },
                          on: { click: _vm.resetForm },
                        },
                        [
                          _c("v-icon", { attrs: { small: "", left: "" } }, [
                            _vm._v("mdi-refresh"),
                          ]),
                          _vm._v(" " + _vm._s(_vm.$t("reset")) + " "),
                        ],
                        1
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "primary",
                            disabled: !_vm.canGenerate,
                          },
                          on: { click: _vm.downloadConfig },
                        },
                        [
                          _c("v-icon", { attrs: { small: "", left: "" } }, [
                            _vm._v("mdi-download"),
                          ]),
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("yealink-config-download")) +
                              " "
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-tooltip",
                        {
                          attrs: { top: "", disabled: !!_vm.selectedDeviceId },
                          scopedSlots: _vm._u([
                            {
                              key: "activator",
                              fn: function ({ on, attrs }) {
                                return [
                                  _c(
                                    "span",
                                    _vm._g(
                                      _vm._b({}, "span", attrs, false),
                                      on
                                    ),
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "white--text",
                                          attrs: {
                                            color: "cyan",
                                            disabled:
                                              !_vm.canGenerate ||
                                              !_vm.selectedDeviceId,
                                            loading: _vm.pushing,
                                          },
                                          on: { click: _vm.pushToYmcs },
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { small: "", left: "" } },
                                            [_vm._v("mdi-cloud-upload")]
                                          ),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "yealink-config-push-ymcs"
                                                )
                                              ) +
                                              " "
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("yealink-config-push-ymcs-no-device")
                              )
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
          _c(
            "v-dialog",
            {
              attrs: {
                "max-width": "720",
                persistent: "",
                fullscreen: _vm.$vuetify.breakpoint.xsOnly,
                "content-class": "yealink-fullwidth-dialog",
              },
              model: {
                value: _vm.networkDiffDialog,
                callback: function ($$v) {
                  _vm.networkDiffDialog = $$v
                },
                expression: "networkDiffDialog",
              },
            },
            [
              _c(
                "v-card",
                { staticClass: "yealink-dialog-card" },
                [
                  _c(
                    "v-card-title",
                    { staticClass: "yealink-dialog-title blue-grey lighten-5" },
                    [
                      _c(
                        "v-icon",
                        {
                          staticClass: "mr-2",
                          attrs: { color: "blue-grey darken-2" },
                        },
                        [_vm._v("mdi-sync")]
                      ),
                      _c(
                        "span",
                        {
                          staticClass:
                            "text-subtitle-1 font-weight-bold blue-grey--text text--darken-4",
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("yealink-config-network-diff-title")
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _c(
                    "v-card-text",
                    { staticClass: "yealink-dialog-text" },
                    [
                      _c("p", { staticClass: "yealink-dialog-lead mb-2" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("yealink-config-network-diff-lead")) +
                            " "
                        ),
                      ]),
                      _c("p", { staticClass: "yealink-dialog-body mb-4" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("yealink-config-network-diff-explanation")
                            ) +
                            " "
                        ),
                      ]),
                      _c(
                        "p",
                        { staticClass: "yealink-dialog-scope-note mb-2" },
                        [
                          _c(
                            "v-icon",
                            {
                              staticClass: "mr-1",
                              attrs: {
                                "x-small": "",
                                color: "blue-grey darken-1",
                              },
                            },
                            [_vm._v("mdi-information-outline")]
                          ),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("yealink-config-network-diff-scope-note")
                              ) +
                              " "
                          ),
                        ],
                        1
                      ),
                      _c("v-simple-table", {
                        staticClass: "network-diff-table mb-5",
                        attrs: { dense: "" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function () {
                              return [
                                _c("thead", [
                                  _c("tr", [
                                    _c("th", { staticClass: "text-left" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "yealink-config-network-diff-variable"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]),
                                    _c("th", { staticClass: "text-left" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "yealink-config-network-diff-previous"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]),
                                    _c("th", { staticClass: "text-left" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "yealink-config-network-diff-applied"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]),
                                  ]),
                                ]),
                                _c(
                                  "tbody",
                                  _vm._l(_vm.networkDiffs, function (d) {
                                    return _c("tr", { key: d.key }, [
                                      _c(
                                        "td",
                                        {
                                          staticClass:
                                            "font-weight-medium yealink-diff-key",
                                        },
                                        [_vm._v(" " + _vm._s(d.key) + " ")]
                                      ),
                                      _c(
                                        "td",
                                        {
                                          staticClass: "yealink-diff-previous",
                                        },
                                        [
                                          _vm._v(
                                            " " + _vm._s(d.previousLabel) + " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "td",
                                        { staticClass: "yealink-diff-applied" },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              staticClass: "mr-1",
                                              attrs: {
                                                "x-small": "",
                                                color: "success",
                                              },
                                            },
                                            [_vm._v("mdi-arrow-right-bold")]
                                          ),
                                          _vm._v(
                                            " " + _vm._s(d.appliedLabel) + " "
                                          ),
                                        ],
                                        1
                                      ),
                                    ])
                                  }),
                                  0
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                      }),
                      _c(
                        "h4",
                        { staticClass: "yealink-dialog-section-title mb-2" },
                        [
                          _c(
                            "v-icon",
                            {
                              staticClass: "mr-1",
                              attrs: { small: "", color: "blue-grey darken-2" },
                            },
                            [_vm._v("mdi-magnify")]
                          ),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "yealink-config-network-diff-review-title"
                                )
                              ) +
                              " "
                          ),
                        ],
                        1
                      ),
                      _c("p", { staticClass: "yealink-dialog-body mb-2" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("yealink-config-network-diff-review-intro")
                            ) +
                            " "
                        ),
                      ]),
                      _c("ul", { staticClass: "yealink-dialog-list mb-3" }, [
                        _c("li", [
                          _vm._v(
                            _vm._s(_vm.$t("yealink-config-network-diff-risk-1"))
                          ),
                        ]),
                        _c("li", [
                          _vm._v(
                            _vm._s(_vm.$t("yealink-config-network-diff-risk-2"))
                          ),
                        ]),
                        _c("li", [
                          _vm._v(
                            _vm._s(_vm.$t("yealink-config-network-diff-risk-3"))
                          ),
                        ]),
                      ]),
                      _c("p", { staticClass: "yealink-dialog-closing mb-4" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("yealink-config-network-diff-closing")
                            ) +
                            " "
                        ),
                      ]),
                      _c(
                        "v-alert",
                        {
                          staticClass: "mb-0 yealink-dialog-alert",
                          attrs: {
                            dense: "",
                            outlined: "",
                            type: "error",
                            icon: "mdi-alert-octagon",
                          },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "text-body-2 font-weight-medium" },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "yealink-config-network-diff-warning"
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _c(
                    "v-card-actions",
                    { staticClass: "yealink-dialog-actions" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass:
                            "yealink-dialog-btn yealink-dialog-btn-danger",
                          attrs: {
                            color: _vm.revertConfirmArmed
                              ? "error darken-2"
                              : "error",
                            depressed:
                              !_vm.$vuetify.breakpoint.xsOnly ||
                              _vm.revertConfirmArmed,
                            outlined:
                              _vm.$vuetify.breakpoint.xsOnly &&
                              !_vm.revertConfirmArmed,
                            large: _vm.$vuetify.breakpoint.xsOnly,
                            block: _vm.$vuetify.breakpoint.xsOnly,
                          },
                          on: { click: _vm.onRevertClick },
                        },
                        [
                          _c("v-icon", { attrs: { small: "", left: "" } }, [
                            _vm._v(
                              _vm._s(
                                _vm.revertConfirmArmed
                                  ? "mdi-alert"
                                  : "mdi-undo-variant"
                              )
                            ),
                          ]),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.revertConfirmArmed
                                  ? _vm.$t(
                                      "yealink-config-network-diff-revert-confirm"
                                    )
                                  : _vm.$t("yealink-config-network-diff-revert")
                              ) +
                              " "
                          ),
                        ],
                        1
                      ),
                      !_vm.$vuetify.breakpoint.xsOnly
                        ? _c("v-spacer")
                        : _vm._e(),
                      _c(
                        "v-btn",
                        {
                          staticClass:
                            "yealink-dialog-btn yealink-dialog-btn-safe",
                          attrs: {
                            color: "primary",
                            depressed: "",
                            large: _vm.$vuetify.breakpoint.xsOnly,
                            block: _vm.$vuetify.breakpoint.xsOnly,
                          },
                          on: { click: _vm.acceptNetworkSettings },
                        },
                        [
                          _c("v-icon", { attrs: { small: "", left: "" } }, [
                            _vm._v("mdi-check"),
                          ]),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("yealink-config-network-diff-accept")
                              ) +
                              " "
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-dialog",
            {
              attrs: {
                "max-width": "600",
                persistent: "",
                fullscreen: _vm.$vuetify.breakpoint.xsOnly,
                "content-class": "yealink-fullwidth-dialog",
              },
              model: {
                value: _vm.deployGateDialog,
                callback: function ($$v) {
                  _vm.deployGateDialog = $$v
                },
                expression: "deployGateDialog",
              },
            },
            [
              _c(
                "v-card",
                { staticClass: "yealink-dialog-card" },
                [
                  _c(
                    "v-card-title",
                    { staticClass: "yealink-dialog-title red lighten-5" },
                    [
                      _c(
                        "v-icon",
                        { staticClass: "mr-2", attrs: { color: "error" } },
                        [_vm._v("mdi-alert-octagon-outline")]
                      ),
                      _c(
                        "span",
                        {
                          staticClass:
                            "text-subtitle-1 font-weight-bold red--text text--darken-4",
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("yealink-config-deploy-gate-title")
                              ) +
                              " "
                          ),
                        ]
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { icon: "", small: "" },
                          on: { click: _vm.cancelDeployGate },
                        },
                        [_c("v-icon", [_vm._v("mdi-close")])],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _c(
                    "v-card-text",
                    { staticClass: "yealink-dialog-text" },
                    [
                      _c("p", { staticClass: "yealink-dialog-lead mb-2" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("yealink-config-deploy-gate-lead")) +
                            " "
                        ),
                      ]),
                      _c("p", { staticClass: "yealink-dialog-body mb-4" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("yealink-config-deploy-gate-explanation")
                            ) +
                            " "
                        ),
                      ]),
                      _c("p", { staticClass: "yealink-dialog-body mb-2" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "yealink-config-deploy-gate-benefits-intro"
                              )
                            ) +
                            " "
                        ),
                      ]),
                      _c("ul", { staticClass: "yealink-dialog-list mb-4" }, [
                        _c("li", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("yealink-config-deploy-gate-benefit-1")
                            )
                          ),
                        ]),
                        _c("li", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("yealink-config-deploy-gate-benefit-2")
                            )
                          ),
                        ]),
                        _c("li", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("yealink-config-deploy-gate-benefit-3")
                            )
                          ),
                        ]),
                      ]),
                      _c(
                        "v-alert",
                        {
                          staticClass: "mb-0 yealink-dialog-alert",
                          attrs: {
                            dense: "",
                            outlined: "",
                            type: "error",
                            icon: "mdi-alert-octagon",
                          },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "text-body-2 font-weight-medium" },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("yealink-config-deploy-gate-warning")
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _c(
                    "v-card-actions",
                    { staticClass: "yealink-dialog-actions" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass:
                            "yealink-dialog-btn yealink-dialog-btn-danger",
                          attrs: {
                            color: _vm.deployConfirmArmed
                              ? "error darken-2"
                              : "error",
                            depressed:
                              !_vm.$vuetify.breakpoint.xsOnly ||
                              _vm.deployConfirmArmed,
                            outlined:
                              _vm.$vuetify.breakpoint.xsOnly &&
                              !_vm.deployConfirmArmed,
                            large: _vm.$vuetify.breakpoint.xsOnly,
                            block: _vm.$vuetify.breakpoint.xsOnly,
                          },
                          on: { click: _vm.onDeployGateClick },
                        },
                        [
                          _c("v-icon", { attrs: { small: "", left: "" } }, [
                            _vm._v(
                              _vm._s(
                                _vm.deployConfirmArmed
                                  ? "mdi-alert"
                                  : "mdi-rocket-launch"
                              )
                            ),
                          ]),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.deployConfirmArmed
                                  ? _vm.$t(
                                      "yealink-config-deploy-gate-confirm-again"
                                    )
                                  : _vm.$t("yealink-config-deploy-gate-confirm")
                              ) +
                              " "
                          ),
                        ],
                        1
                      ),
                      !_vm.$vuetify.breakpoint.xsOnly
                        ? _c("v-spacer")
                        : _vm._e(),
                      _c(
                        "v-btn",
                        {
                          staticClass:
                            "yealink-dialog-btn yealink-dialog-btn-safe",
                          attrs: {
                            color: "primary",
                            depressed: "",
                            large: _vm.$vuetify.breakpoint.xsOnly,
                            block: _vm.$vuetify.breakpoint.xsOnly,
                          },
                          on: { click: _vm.cancelDeployGate },
                        },
                        [
                          _c("v-icon", { attrs: { small: "", left: "" } }, [
                            _vm._v("mdi-close"),
                          ]),
                          _vm._v(" " + _vm._s(_vm.$t("cancel")) + " "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }